import {useState} from "react";

import {InfoCard} from "layout/InfoCard";
import "./LoadError.css";

type Props = {
  title: string;
  summary: string;
  error: unknown;
  retry: () => unknown;
};

function describeError(error: unknown): string | null {
  if (error instanceof Error) return error.message;
  return typeof error === "string" ? error : null;
}

function requestId(error: unknown): string | null {
  if (!error || typeof error !== "object" || !("envelope" in error)) return null;
  const envelope = error.envelope;
  if (!envelope || typeof envelope !== "object" || !("requestId" in envelope)) return null;
  return typeof envelope.requestId === "string" ? envelope.requestId : null;
}

export function LoadError({title, summary, error, retry}: Props) {
  const [isRetrying, setIsRetrying] = useState(false);
  const detail = describeError(error);
  const errorRequestId = requestId(error);

  const handleRetry = async () => {
    setIsRetrying(true);
    try {
      await retry();
    } finally {
      setIsRetrying(false);
    }
  };

  return (
    <div className="load-error-container" role="alert">
      <InfoCard className="load-error-card">
        <h2>{title}</h2>
        <p>{summary}</p>
        {detail && <p className="load-error-detail">{detail}</p>}
        {errorRequestId && <p className="load-error-request-id">Request ID: {errorRequestId}</p>}
        <button className="load-error-retry" onClick={handleRetry} disabled={isRetrying}>
          {isRetrying ? "Retrying…" : "Retry"}
        </button>
      </InfoCard>
    </div>
  );
}
